<template>
  <div id="checkout-container" class="container">
    <slot name="header"></slot>

    <address-selector
      :initial-billing-addresses="initialBillingAddresses"
      :initial-shipping-addresses="initialShippingAddresses"
      :region-label="regionLabel"
      :regions="regions"
      :countries="countries"
      :country="country"
      :save-address-route="saveAddressRoute"
      @address-changed="addressChanged"
    >
    </address-selector>

    <div class="row sep-top-xs sep-bottom-sm">
      <div class="col-md-6 checkout-main">
        <order-summary
          :product-total="productTotal"
          :currency-label="currencyLabel"
          :manage-exemptions-route="manageExemptionsRoute"
          :estimate-tax-route="estimateTaxRoute"
          :shipping-address-id="shippingAddressId"
        >
        </order-summary>
      </div>

      <div class="visible-xs visible-sm sep-top-xs sep-bottom-sm"></div>

      <payment-methods
        :can-checkout="canCheckout"
        :has-bank="hasBank"
        :manage-bank-route="manageBankRoute"
        :has-wallet="hasWallet"
        :billing-address="selectedBillingAddress"
        :shipping-address-id="shippingAddressId"
        :currency="currencyLabel.toLowerCase()"
        :create-customer-card-route="createCustomerCardRoute"
        :credit-cards="creditCards"
        :wallet-cards="walletCards"
        :bank-accounts="bankAccounts"
        :bank-retry-payment-terms="bankRetryPaymentTerms"
        @checkout="checkout"
      >
      </payment-methods>
    </div>
    <form
      id="checkout-form"
      ref="checkoutForm"
      method="post"
      name="checkoutForm"
      :action="checkoutRoute"
    >
      <slot name="csrf"></slot>
      <input
        :value="billingAddressId"
        name="billing_address_id"
        type="hidden"
      />
      <input
        :value="shippingAddressId"
        name="shipping_address_id"
        type="hidden"
      />
      <input :value="checkoutMethod" name="checkout_method" type="hidden" />
      <input :value="cardId" name="card_id" type="hidden" />
      <input :value="customerPO" name="customerPO" type="hidden" />
      <input
        v-for="(terms, index) in termsBoxes"
        :key="index"
        :name="terms"
        :value="terms"
        type="hidden"
      />
    </form>
  </div>
</template>

<script>
import swal from "sweetalert2";
import AddressSelector from "./AddressSelector.vue";
import OrderSummary from "./OrderSummary.vue";
import PaymentMethods from "./PaymentMethods.vue";

export default {
  components: {
    AddressSelector,
    OrderSummary,
    PaymentMethods,
  },
  props: {
    initialBillingAddresses: {
      type: Array,
      required: true,
    },
    initialShippingAddresses: {
      type: Array,
      required: true,
    },
    regionLabel: {
      type: String,
      required: true,
    },
    regions: {
      type: Object,
      required: true,
    },
    countries: {
      type: Object,
      required: true,
    },
    country: {
      type: String,
      required: true,
    },
    saveAddressRoute: {
      type: String,
      required: true,
    },
    productTotal: {
      type: Number,
      required: true,
    },
    currencyLabel: {
      type: String,
      required: true,
    },
    manageExemptionsRoute: {
      type: String,
      required: true,
    },
    estimateTaxRoute: {
      type: String,
      required: true,
    },
    canCheckout: {
      type: Boolean,
      required: true,
    },
    hasBank: {
      type: Boolean,
      required: true,
    },
    manageBankRoute: {
      type: String,
      required: true,
    },
    hasWallet: {
      type: Boolean,
      required: true,
    },
    checkoutRoute: {
      type: String,
      required: true,
    },
    createCustomerCardRoute: {
      type: String,
      required: true,
    },
    creditCards: {
      type: Array,
      required: true,
    },
    walletCards: {
      type: Array,
      required: true,
    },
    bankAccounts: {
      type: Array,
      required: true,
    },
    bankRetryPaymentTerms: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      billingAddressId: 0,
      billingAddresses: this.initialBillingAddresses,
      shippingAddressId: 0,
      checkoutMethod: null,
      cardId: null,
      customerPO: null,
      termsBoxes: [],
    };
  },

  computed: {
    selectedBillingAddress() {
      return (
        this.billingAddresses.find(
          (address) => address.id === this.billingAddressId
        ) || { id: 0 }
      );
    },
  },

  methods: {
    addressChanged(payload) {
      if (payload.addressType === "billing") {
        this.billingAddressId = payload.addressId;
      } else {
        this.shippingAddressId = payload.addressId;
      }
    },

    checkout(payload) {
      swal.fire({ title: "Processing...", padding: "2.5em" });
      swal.showLoading();

      this.checkoutMethod = payload.checkoutType;
      this.cardId = payload.cardId;
      this.termsBoxes = payload.termsBoxes;

      // get items from DOM that are injected via the header slot
      this.customerPO = $("#customerPO").val();

      // important to have the DOM update before we submit the form
      window.Vue.nextTick(() => {
        this.$refs.checkoutForm.submit();
      }, this);
    },
  },
};
</script>
